import type { Notification } from 'entities/notification';

import { NOTIFICATION_STATUSES } from '../model';

export function hasNotificationIssue(notification: Notification) {
  const { uds_messagetypecode } = notification.attributes;

  return (
    uds_messagetypecode.value === NOTIFICATION_STATUSES.WARNING ||
    uds_messagetypecode.value === NOTIFICATION_STATUSES.ERROR
  );
}
